import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { Button } from 'hb4e-ui-core-ui'
import { ProductService, ProductConstants, launchSimulation, launchHtmlProduct } from 'hb4e-ui-product'

import { getProductDetailsForListItem } from '../../../../list-service'

const { isSNETItem, isDownloadableProduct } = ProductService
const { productLinkTypes } = ProductConstants

export const ListItemLaunchButton = ({ item }) => {
  const dispatch = useDispatch()
  const product = item?.product

  const { productLink, isExpired } = getProductDetailsForListItem(item)

  if (productLink && !isSNETItem(product) && !isDownloadableProduct(product)) {
    const { label, url, linkType } = productLink

    const handleLaunchClick = () => {
      if (linkType === productLinkTypes.SIMULATION) {
        dispatch(launchSimulation(url, 'student', product))
      } else {
        dispatch(launchHtmlProduct(url))
      }
    }

    return (
      <Button theme="primary outline" onClick={handleLaunchClick} disabled={isExpired}>
        {label}
      </Button>
    )
  }

  return null
}

ListItemLaunchButton.propTypes = {
  item: PropTypes.object.isRequired,
}

export default ListItemLaunchButton
